import { removeTypename } from '@/helpers/utils'

export default {
  hotsiteSlot: (state) => state.hotsiteSlot,
  productionConfiguration: (state) => state.productionConfiguration,
  previewConfiguration: (state) => state.previewConfiguration,
  currentConfiguration: (state) => {
    // Ensure currentConfiguration has the basic structure
    if (!state.currentConfiguration) return {}

    return {
      ...state.currentConfiguration,
      overrides: {
        facebook_pixel_id: null,
        google_analytics_id: null,
        signup_tag: null,
        ...state.currentConfiguration.overrides,
      },
    }
  },
  colors: (state) => state.colors,
  images: (state) => state.images,
  positions: (state) => state.positions,
  fields: (state) => state.fields,
  overrides: (state) => state.overrides,
  loading: (state) => state.loading,
  error: (state) => state.error,
  hasData: (state) => !!state.hotsiteSlot,
  hasProductionConfig: (state) => !!state.productionConfiguration,
  hasPreviewConfig: (state) => !!state.previewConfiguration,
  defaultConfigurationSettings: (state) => state.defaultConfigurationSettings,
  // Get colors with fallback to default structure
  colorsWithDefaults: (state) => {
    // First check the existing separate colors state slice
    if (Object.keys(state.colors).length > 0) {
      return state.colors
    }
    // Then check currentConfiguration.assets.colors (new pattern)
    const currentColors = state.currentConfiguration?.assets?.colors
    if (currentColors && Object.keys(currentColors).length > 0) {
      return currentColors
    }
    // Finally fallback to defaults
    return state.defaultConfigurationSettings.assets.colors
  },
  // Get images with fallback to default structure
  imagesWithDefaults: (state) => {
    // First check the existing separate images state slice
    if (Object.keys(state.images).length > 0) {
      return state.images
    }
    // Then check currentConfiguration.assets.images (new pattern)
    const currentImages = state.currentConfiguration?.assets?.images
    if (currentImages && Object.keys(currentImages).length > 0) {
      return currentImages
    }
    // Finally fallback to defaults
    return state.defaultConfigurationSettings.assets.images
  },
  // Get positions with fallback to default structure
  positionsWithDefaults: (state) => {
    // First check the existing separate positions state slice
    if (Object.keys(state.positions).length > 0) {
      return state.positions
    }
    // Then check currentConfiguration.assets.positions (new pattern)
    const currentPositions = state.currentConfiguration?.assets?.positions
    if (currentPositions && Object.keys(currentPositions).length > 0) {
      return currentPositions
    }
    // Finally fallback to defaults
    return state.defaultConfigurationSettings.assets.positions
  },
  // Get fields with fallback to default structure
  fieldsWithDefaults: (state) => {
    // First check the existing separate fields state slice
    if (Object.keys(state.fields).length > 0) {
      return state.fields
    }
    // Then check currentConfiguration.fields (new pattern)
    const currentFields = state.currentConfiguration?.fields
    if (currentFields && Object.keys(currentFields).length > 0) {
      return currentFields
    }
    // Finally fallback to defaults
    return state.defaultConfigurationSettings.fields
  },
  // Get overrides with fallback to default structure
  overridesWithDefaults: (state) => {
    // First check the existing separate overrides state slice
    if (Object.keys(state.overrides).length > 0) {
      return state.overrides
    }
    // Then check currentConfiguration.overrides (new pattern)
    const currentOverrides = state.currentConfiguration?.overrides
    if (currentOverrides && Object.keys(currentOverrides).length > 0) {
      return currentOverrides
    }
    // Finally fallback to defaults
    return state.defaultConfigurationSettings.overrides
  },
  currentConfigurationToSave: (state) => {
    const settings = removeTypename(state.currentConfiguration.settings)
    const overrides = removeTypename(state.currentConfiguration.overrides)

    // Remove index field from fields in settings
    if (settings?.fields) {
      if (settings.fields.natural && Array.isArray(settings.fields.natural)) {
        settings.fields.natural = settings.fields.natural.map((field) => {
          const { index, ...fieldWithoutIndex } = field
          return fieldWithoutIndex
        })
      }
      if (settings.fields.legal && Array.isArray(settings.fields.legal)) {
        settings.fields.legal = settings.fields.legal.map((field) => {
          const { index, ...fieldWithoutIndex } = field
          return fieldWithoutIndex
        })
      }
    }

    return {
      settings,
      overrides,
    }
  },
  validationErrors: (state) => state.validationErrors,
  hasValidationErrors: (state) => {
    return Object.keys(state.validationErrors.tabs).length > 0 || Object.keys(state.validationErrors.fields).length > 0
  },
  getTabValidationErrors: (state) => (tabIndex) => {
    return state.validationErrors.tabs[tabIndex] || []
  },
  getFieldValidationError: (state) => (fieldPath) => {
    return state.validationErrors.fields[fieldPath] || null
  },
}
